








































import { defineComponent } from "@vue/composition-api";
import { CreditCardAssignment } from "@scrile/api-provider/dist/api/CreditCardAssignmentsProvider";
import { PaymentSystemPublic } from "@scrile/api-provider/dist/api/PaymentSystemsProvider";
import useBalance from "@/hooks/useBalance";
import { formatMoneyString } from "@/lib/moneyHelpers";
import { getAcceptedPayments, isBalanceSystem } from "@/lib/paymentSystemsHelpers";
import { IntegrationType } from "@/payments/integrations/const";
import BaseIcon from "@/components/Base/BaseIcon";
import EmptyContent from "@/components/EmptyContent";

export interface PaymentSystemListItem {
  system: PaymentSystemPublic;
  name: string;
  logo?: string;
  card?: CreditCardAssignment;
  type?: IntegrationType;
}

export default defineComponent({
  name: "PaymentMethodsList",
  components: { BaseIcon, EmptyContent },
  props: {
    systems: { type: Array as () => PaymentSystemListItem[], required: true },
    value: { type: String },
  },
  setup() {
    const { balance } = useBalance();
    return { balance, formatMoneyString, isBalanceSystem, getAcceptedPayments };
  },
});
